<template>
    <div class="has-clip">
    
    <div class="wrapper--section" :class="{
        'section--styled has-wave': styled === 'yes',
    }" :style="`--bg: ${background}`">

        <WithWave v-bind="{ styled }" />
    
        <div class="section-container has-overflow">
            <h2 class="title title--dash" v-html="title" />

            <section
                id="gallery-text"
                class="text-gallery has-overflow"
                aria-labelledby="gallery-heading"
                aria-describedby="gallery-status"
            >
                <p 
                    id="gallery-text"
                    class="sr-only"
                    aria-live="polite" aria-atomic="true"
                    v-html="`Slide ${selected + 1} of ${items.length}`"
                />

                <span aria-hidden="true" class="slider-index" v-html="readableIndex" />

                <transition-group tag="div" class="member-slides" name="fade">
                    <div
                        v-for="(item, i) in items"
                        :key="currentSlide + i"
                        v-show="selected === i"
                        role="group"
                        class="text-slide"
                        :aria-label="`Slide ${i + 1} of ${items.length}`"
                        :aria-hidden="selected !== i"
                    >

                        <h3 class="title title--light title--slide" v-html="item.title" />

                        <article
                            class="section__text" 
                            v-html="item.text"
                        />

                        <ul v-if="item.items">
                            <li v-for="({button}) in item.items" :key="button.url">
                                <SectionButton 
                                    :button="button"
                                    :classes="''"
                                />
                            </li>
                        </ul>

                    </div>
                </transition-group>
                
                <div class="gallery__nav" data-flex="row keep">
                    <arrow-button
                        type="prev"
                        text="Prev"
                        class="screen"
                        :label="`Prev, slide ${this.selected}`"
                        :disabled="!isPrev"
                        @click.native="prev"
                        aria-controls="carousel-testimonials"
                    />
                    
                    <arrow-button
                        type="next"
                        text="Next"
                        class="screen"
                        :label="`Next, slide ${(this.selected + 2)}`"
                        :disabled="!isNext"
                        @click.native="next"
                        aria-controls="carousel-testimonials"
                    />
                </div>
            </section>

        </div>
        
    </div>
    </div>
</template>

<script>
import { textProps, optionsProps } from './sectionProps'
import { sectionSlider } from './sectionSlider'
import SectionButton from './SectionButton.vue'
import WithWave from './WithWave.vue';

export default {
    props: {
        styled: String,
        items: {
            type: [Array, Boolean],
            required: true
        },
        ...textProps,
        ...optionsProps,
    },

    components: {
        SectionButton,
        WithWave,
    },

    mixins: [
        sectionSlider,
    ],
}
</script>

<style lang="scss" scoped>
.section__text {
    display: grid;
    gap: 1.25em;
    grid-auto-rows: max-content;

    ::v-deep strong {
        color: var(--purple);
        font-weight: 600;
    }
}

.section--styled {
    color: #fff;

    .title--light {
        font-weight: 600;
    }

    .title--dash {
        color: currentColor;
        margin-bottom: 1em;
    }

    [class*=fade-leave] {
        opacity: 0;
        position: absolute;
        transition: none;
    }
}

.title--slide {
    margin-top: 1.25em;
}

.text-gallery {
    border-radius: 1rem;
    background: #fff;
    position: relative;
    overflow: hidden;
    padding: 2rem;

    ::v-deep a {
        color: var(--purple);
        text-decoration: underline;
        text-underline-offset: 0.1em;

        &:hover {
            text-decoration: none;
        }
    }
}

.text-slide {
    display: grid;
    gap: 1rem;

    li {
        padding-block: .175em;
    }
}

.gallery__nav {
    margin-block-start: 2rem;
    gap: 2rem;
}

@media (width > 767px) {
    .has-wave {
        padding-block-start: 2rem;
    }
    .title--dash {
        text-align: center;
    }
    .title--slide {
        margin-bottom: 2em;
        grid-row: 1 / span 2;
    }
    .gallery__nav {
        margin-block-start: -1.75rem;
    }
    .text-gallery {
        padding: 3rem;
    }
    .text-slide {
        grid-template-columns: 1fr 1.25fr;
        text-align: left;

        > :nth-child(2),
        > :nth-child(3) {
            grid-column: 2;
        }

        ul:has(a) {
            columns: 2;
        }
    }
    .section__text:last-child {
        margin-block: auto;
        grid-row: span 2;
    }
}

</style>